import { ReportDefinition } from '../models/report.model';

/**
 * Compares two report definitions for equality, ignoring storage metadata
 * (`id`, `visibility`) that isn't part of the user-editable criteria — `id` is
 * absent on freshly-built definitions and `visibility` is changed only via the
 * dedicated share/unshare actions, never through the builder.
 */
export function definitionsEqual(
  a: ReportDefinition | null,
  b: ReportDefinition | null,
): boolean {
  if (!a || !b) return a === b;
  const strip = (def: ReportDefinition) => {
    const { id, visibility, ...rest } = def;
    return rest;
  };
  return JSON.stringify(strip(a)) === JSON.stringify(strip(b));
}
